import { z } from 'zod';

import { createApi } from '../core';
import { ESSLRecord, Subscription } from '../types/subscription';

export const subscriptionApi = createApi.group(['subscription'], (createKey) => {
  return {
    getAll: createApi.query({
      queryKey: createKey(['getAllSubscriptions']),
      queryFn: () => {
        return createApi.fetch({
          path: ['cluey-plus', 'subscriptions'],
          method: 'GET',
          validator: z.array(Subscription),
          basePath: 'portalAPI',
          sign: true,
        });
      },
      refetchOnWindowFocus: false,
    }),
    esslRecords: createApi.query({
      queryKey: createKey(['getEsslRecords']),
      queryFn: (params: { studentId: string }) => {
        return createApi.fetch({
          path: ['cluey-plus', 'essl-records'],
          method: 'GET',
          query: {
            student_sfid: params.studentId,
          },
          validator: z.object({
            message: z.string(),
            data: z.array(ESSLRecord),
          }),
          basePath: 'portalAPI',
          sign: true,
        });
      },
      refetchOnWindowFocus: false,
    }),
    checkSubscription: createApi.query({
      queryKey: createKey(['checkSubs']),
      queryFn: () => {
        return createApi.fetch({
          path: ['check-subscription'],
          method: 'GET',
          validator: z.object({
            hasValidSubscription: z.boolean(),
          }),
          basePath: 'studentHubAPI',
          sign: true,
        });
      },
      refetchOnWindowFocus: false,
    }),
    checkEnrolmentSubscription: createApi.query({
      queryKey: createKey(['checkEnrolmentSubs']),
      queryFn: (params: { enrolmentId: string }) => {
        return createApi.fetch({
          path: ['check-subscription', 'enrolment', params.enrolmentId],
          method: 'GET',
          validator: z.object({
            hasValidSubscription: z.boolean(),
          }),
          basePath: 'studentHubAPI',
          sign: true,
        });
      },
      refetchOnWindowFocus: false,
    }),
  };
});
